<template>
<div class="" v-bind:class="{'now_loading': (this.loading)}">
  <SelectItem v-bind:bc="bc" v-bind:selectItem="this.detailItem" v-on:detailClose="selectItemClose" v-on:addItem="addItem" />
  <div v-show="loading" class="loader loader_bg--gray"></div>
  <div v-show="!loading" v-for="(value, index) in productList" class="products_wrap bg_white mt12 pt16 pb24 boxs1" v-bind:key="value.genreId">
    <h2 class="content_title" v-bind:class="[value.genreId == 100 ? 'orange' : '', ]">{{ value.genreName }}</h2>
    <div class="product_list">
      <div v-for="(val, n) in value.itemList" class="product_item" v-bind:class="{ 'select': val.product.cart }" v-on:click="selectItem(val)" :key="val.product.productName">
        <div class="products_main">
          <div class="product_image">
            <img :src="imagePath + val.product.imagePath" :alt="val.product.productName" v-on:error="imageError" :data-noimage="imagePath + val.product.noImagePath">

          </div>
          <!-- {{val.product.cart}} -->
          <h3 class="product_title">{{ val.product.productName }}</h3>
        </div>
        <div class="products_detail">
          <p class="product_price rb"><span class="yen">￥</span>{{ val.product.price.toLocaleString() }}</p>
          <p v-if="val.product.point != 0" class="product_point rb"><span class="point">P</span>{{ val.product.point.toLocaleString() }}</p>
        </div>
      </div>
    </div>
  </div>
</div>
</template>

<script>
import { mapGetters } from 'vuex';
import SelectItem from '@/components/purchase/SelectItem';
import Product from '@/components/api/product';
import scrollPosition from '@/model/scrollPosition';
import Config from '@/config/config';

export default {
  components: {
    SelectItem
  },
  props: ['sendDeleteId'],
  data() {
    return {
      imagePath: Config.APIURL,
      bc: this.purchaseNowBC,
      select: null,
      loading: true,
      productList: [],
      detailItem: {
        image: '',
        noImagePath: '',
        productName: '',
        price: '',
        point: '',
        open: false,
        detail: [
          { year: null, month: 5, count: 0 },
          { year: null, month: 6, count: 0 }
        ],
        productId: 0,
        child: false,
        selectChildFund: false,
        genreId: null,
        maxCount: 0,
      },
      grandChildItem: []
    }

  },
  methods: {
    imageError(e) {
      e.target.src = e.target.dataset.noimage;
    },

    selectItem(data) {
      console.log('selectItem');
      console.log(data);
      scrollPosition.open();
      this.select = data.product.productId;
      // this.detailItem.image = `https://conpus.qwert-bvcxz.com${data.product.imagePath}`;
      this.detailItem.image = Config.APIURL + data.product.imagePath;
      this.detailItem.noImagePath = Config.APIURL + data.product.noImagePath;
      // this.detailItem.image = `https://api.conpus.naturally-plus.com${data.product.imagePath}`; //本番環境

      this.detailItem.productName = data.product.productName;
      this.detailItem.price = data.product.price;
      this.detailItem.point = data.product.point;
      this.detailItem.maxCount = data.product.maxCount;
      this.detailItem.open = true;
      this.detailItem.detail[0].month = data.currentOrderMonth;
      this.detailItem.detail[1].month = data.nextOrderMonth;
      this.detailItem.detail[0].year = data.currentOrderYear;
      this.detailItem.detail[1].year = data.nextOrderYear;
      this.detailItem.productId = data.product.productId;
      this.detailItem.selectChildFund = data.product.selectableChildFund;
      this.detailItem.genreId = data.product.genre.genreId;
      // this.detailItem.cart = true;
      let nowBC = this.purchaseNowBC;
      const values = JSON.parse(localStorage.getItem(nowBC));

      // SelectItemの商品名とnowBCが一致していればcartItemの個数をcountに入れる
      if(values != null) {
        for (var i = 0; i < values.length; i++) {
          if(this.detailItem.productName == values[i].item.title) {
            this.detailItem.detail[0].count = values[i].countItem[0].count;
            this.detailItem.detail[1].count = values[i].countItem[1].count;
            this.detailItem.child = values[i].child;
            return true;
          }
          else {
            this.detailItem.detail[0].count = 0;
            this.detailItem.detail[1].count = 0;
            this.detailItem.child = false;
          }
        }
      }
      // console.log(this.detailItem.count);
    },
    selectItemClose(close) {
      this.detailItem.open = close;
    },
    addItem(item) {
      for (var i = 0; i < this.productList.length; i++) {
        let res = this.productList[i].itemList.findIndex((val) => val.product.productId == item.productId);
        if(res != -1) {
          this.productList[i].itemList[res].product.cart = true;
        }
      }
      this.grandChildItem = item;
      this.childItemEmit();
    },
    childItemEmit() {
      this.$emit('addItemChild', this.grandChildItem);
    },
    async getProducts(bc) {

      this.loading = true;
      // let bc;
      // if(this.$route.query.bc) {
      //   bc = this.$route.query.bc;
      // } else {
      //   bc = this.nowBC;
      // }
      // let cartItems = JSON.parse(localStorage.getItem(bc));
      let cartItems = JSON.parse(localStorage.getItem(this.purchaseNowBC));
      await Product.purchases(this.purchaseNowBC).then((val) => {;
        this.productList.splice(0, this.productList.length);
        this.$store.commit('setPurchaseCurrentOrderMonth', val.productList[0].currentOrderMonth);
        for (var i = 0; i < val.genreList.length; i++) {
          let items = {
            genreId: val.genreList[i].genreId,
            genreName: val.genreList[i].genreName,
            itemList: []
          }
          for (var a = 0; a < val.productList.length; a++) {
            if(val.genreList[i].genreId == val.productList[a].product.genre.genreId) {
              if(cartItems && cartItems.length != 0) {
                let res = cartItems.some((value) => value.productId == val.productList[a].product.productId)
                res ? val.productList[a].product.cart = true: val.productList[a].product.cart = false;
              } else {
                val.productList[a].product.cart = false;
              }

              items.itemList.push(val.productList[a]);
            }
          }
          if (items.itemList.length != 0) {
            this.productList.push(items);
          }

        }
        this.loading = false;
        this.checkCartData(val.productList);
      });
    },
    checkCartData(list) {
      let bcItem = JSON.parse(localStorage.getItem(this.purchaseNowBC));
      if(bcItem) {
        for (var a = 0; a < bcItem.length; a++) {
          for (var b = 0; b < list.length; b++) {
            if(list[b].product.productId == bcItem[a].productId) {
              // 月を跨いだ場合ストレージ（カート）の商品の年、月を更新する
              (list[b].currentOrderYear != bcItem[a].countItem[0].year) ? bcItem[a].countItem[0].year = list[b].currentOrderYear: '';
              (list[b].currentOrderMonth != bcItem[a].countItem[0].month) ? bcItem[a].countItem[0].month = list[b].currentOrderMonth: '';
              // (9 != bcItem[a].countItem[0].month) ? bcItem[a].countItem[0].month = 9 : ''; // 月跨ぎテスト用

              (list[b].nextOrderYear != bcItem[a].countItem[1].year) ? bcItem[a].countItem[1].year = list[b].nextOrderYear: '';
              (list[b].nextOrderMonth != bcItem[a].countItem[1].month) ? bcItem[a].countItem[1].month = list[b].nextOrderMonth: '';
              // (10 != bcItem[a].countItem[1].month) ? bcItem[a].countItem[1].month = 10 : ''; // 月跨ぎテスト用
            }
          }
        }

      }
      let updateItem = [];
      for (var c = 0; c < bcItem.length; c++) {
        let exist = list.some(function(listItem) {
          // return 50008 == bcItem[c].productId;
          return listItem.product.productId == bcItem[c].productId;
        });
        exist ? updateItem.push(bcItem[c]) : '';
      }
      localStorage.setItem(this.purchaseNowBC, JSON.stringify(updateItem));

      // let selectBC = JSON.parse(localStorage.getItem('selectBC'));
      // if(selectBC) {
      //   for (var i = 0; i < selectBC.length; i++) {
      //     let bcItem = JSON.parse(localStorage.getItem(selectBC[i]));
      //     if(bcItem) {
      //       for (var a = 0; a < bcItem.length; a++) {
      //         for (var b = 0; b < list.length; b++) {
      //           if(list[b].product.productId == bcItem[a].productId) {
      //             // 月を跨いだ場合ストレージ（カート）の商品の年、月を更新する
      //             (list[b].currentOrderYear != bcItem[a].countItem[0].year) ? bcItem[a].countItem[0].year = list[b].currentOrderYear: '';
      //             (list[b].currentOrderMonth != bcItem[a].countItem[0].month) ? bcItem[a].countItem[0].month = list[b].currentOrderMonth: '';
      //             // (9 != bcItem[a].countItem[0].month) ? bcItem[a].countItem[0].month = 9 : ''; // 月跨ぎテスト用
      //
      //             (list[b].nextOrderYear != bcItem[a].countItem[1].year) ? bcItem[a].countItem[1].year = list[b].nextOrderYear: '';
      //             (list[b].nextOrderMonth != bcItem[a].countItem[1].month) ? bcItem[a].countItem[1].month = list[b].nextOrderMonth: '';
      //             // (10 != bcItem[a].countItem[1].month) ? bcItem[a].countItem[1].month = 10 : ''; // 月跨ぎテスト用
      //           }
      //         }
      //       }
      //
      //     }
      //     let updateItem = [];
      //     for (var c = 0; c < bcItem.length; c++) {
      //       let exist = list.some(function(listItem) {
      //         // return 50008 == bcItem[c].productId;
      //         return listItem.product.productId == bcItem[c].productId;
      //       });
      //       exist ? updateItem.push(bcItem[c]) : '';
      //     }
      //     localStorage.setItem(selectBC[i], JSON.stringify(updateItem));
      //   }
      // }
      this.$emit('checkCartFromApi', true);
    },
  },
  computed: mapGetters(['purchaseNowBC']),
  async created() {
    await this.getProducts(this.purchaseNowBC);
  },

  watch: {
    sendDeleteId() {
      // console.log(this.sendDeleteId);
      for (var i = 0; i < this.productList.length; i++) {
        // console.log(this.productList[i].itemList);
        let res = this.productList[i].itemList.findIndex((value) => value.product.productId == this.sendDeleteId);
        // console.log(res);
        if(res != -1) {
          this.productList[i].itemList[res].product.cart = false;
        }
      }
    }
  }
}

</script>

<style lang="css" scoped>
.orange {
  background-color: #FFA800;
}
</style>



// WEBPACK FOOTER //
// src/components/purchase/ProductsList.vue